import {produce} from 'immer';
import React from 'react';
import {ContentTitle} from 'src/design/atoms/Typography';
import {FormField} from 'src/app/forms/FormField';
import type {IFormFieldV2} from 'src/types/FormV2';
import {
  useGetSelectedField,
  useUpdateSelectedField,
} from '../../../hooks/useFormBuilder';

const includeInactiveField: IFormFieldV2 = {
  name: 'includeInactive',
  label: 'Include inactive personnel',
  type: 'switch',
  description:
    'When enabled, inactive personnel will appear in the person dropdown.',
};

export const PersonSettings = React.memo(() => {
  const field = useGetSelectedField();
  const updateSelectedField = useUpdateSelectedField();

  const handleIncludeInactiveChange = React.useCallback(
    (name: string, value: boolean) => {
      if (!field) return;
      updateSelectedField(
        produce(field, draft => {
          draft.personOptions = {
            ...draft.personOptions,
            includeInactive: value,
          };
        })
      );
    },
    [field, updateSelectedField]
  );

  if (!field || field.type !== 'person') return null;
  return (
    <>
      <ContentTitle text="Person Options" />
      <FormField
        field={includeInactiveField}
        value={field.personOptions?.includeInactive}
        onChange={handleIncludeInactiveChange}
      />
    </>
  );
});
